import { getSelectedCalendars } from 'owa-calendar-surface-calendars-store';
import { getCalendarLoadState } from './getCalendarLoadState';

export function getSelectedCalendarsLoadStates() {
    return [
        ...getSelectedCalendars().map(calendar => getCalendarLoadState(calendar.calendarId.id)),
    ];
}
